import fs from "node:fs"
import path from "node:path"
import type { NextPage } from "next"
import Head from "next/head"

const Privacy: NextPage<{ initialHtmlContent: string }> = ({ initialHtmlContent }) => {
  return (
    <div>
      <Head>
        <title>Privacy Policy</title>
        <link href="/favicon.ico" rel="icon" />
        <style>
          {`
            html, body {
              background-color: #FEFEF9;
            }
            `}
        </style>
      </Head>
      <div
        dangerouslySetInnerHTML={{ __html: initialHtmlContent }}
        style={{
          backgroundColor: "#FEFEF9",
          padding: 24,
        }}
      />
    </div>
  )
}

export function getServerSideProps() {
  const htmlFilePath = path.resolve("./public", "privacy.html")
  const initialHtmlContent = fs.readFileSync(htmlFilePath, "utf8")

  return {
    props: { initialHtmlContent },
  }
}

export default Privacy
